module.exports = __webpack_public_path__ + "static/media/Deeply-Personal.5a5fb0d6.png";